module.exports = __webpack_public_path__ + "img/expert.bf2ae36.png";